/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import MESSANGER from '../BaseComponent/MESSANGER'
import InputMask from 'react-input-mask'

class AddTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  addTemplate() {
    var title = document.getElementById('title').value
    var content = document.getElementById('content').value
    var code = document.getElementById('code').value
    var sortOrder = document.getElementById('sortOrder').value

    var titleError = false
    var contentError = false
    var codeError = false
    var sortOrderError = false
    var formError = false

    if (title === '') {
      titleError = true
      formError = true
      message.error('عنوان وارد شود')
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }
    if (content === '') {
      contentError = true
      formError = true
      message.error('متن را وارد کنید')
    } else {
      if (!contentError) {
        this.setState({
          error: ''
        })
      }
    }

    if (code === '') {
      message.error('کد وارد شود')
      codeError = true
      formError = true
    } else {
      if (!codeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        title,
        content,
        code,
        sortOrder: sortOrder === '' ? undefined : sortOrder
      }

      http
        .post(`${MESSANGER.MESSAGING_TYPE_ADD_TEMPLATE}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('متن از پیش تعریف شده جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/base/messanger/reportTemplate')
            }, 2000)
          } else {
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>پیام رسان</li>
            <li>
              <Link to={'/base/messanger/reportTemplate'}>پیام های از پیش تعریف شده</Link>
            </li>
            <li>افزودن پیام از پیش تعریف شده</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن پیام از پیش تعریف شده</p>
            </div>
            <div className="formComponent">
              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="title" className="form-control" />

              <label>
                متن <span className="requireFiled">*</span>
              </label>
              <input type="text" id="content" className="form-control" />

              <label>
                کد <span className="requireFiled">*</span>
              </label>
              <InputMask
                autocomplete="off"
                id="code"
                placeholder="عدد"
                className="form-control"
                mask="999999999"
                maskChar={null}
              />

              <label>ترتیب نمایش</label>

              <InputMask
                autocomplete="off"
                id="sortOrder"
                placeholder="عدد"
                className="form-control"
                mask="999999999"
                maskChar={null}
              />

              <button className="btn btn-info btn-block" onClick={this.addTemplate.bind(this)}>
                ثبت نمونه پیام
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddTemplate
